import React, { useEffect } from "react";
import useHover from "../hooks/useHover";
import Checkbox from "../misc/elements/Checkbox";
import { forArrayLength } from "../misc/helperfuncs";
import lookupStore from "./lookupStore";
import MainStore from "./MainStore";

const ResultButtons = () => {
  const { displayedField, setDisplayedField, foundStuff } = lookupStore();
  const { setDisplayedBoxes } = MainStore();

  useEffect(() => {
    const boxes = [];
    forArrayLength(foundStuff[displayedField] ?? [], (object) => {
      const newBox = { type: object.type, object, from: displayedField };
      boxes.push(newBox);
    });
    setDisplayedBoxes(boxes);
  }, [displayedField]);

  useEffect(() => {
    if (foundStuff.open.length > 0) setDisplayedField("open");
    else if (foundStuff.saved.length > 0) setDisplayedField("saved");
    else if (foundStuff.general.length > 0) setDisplayedField("general");
    else if (foundStuff.exact.length > 0) setDisplayedField("exact");
    else if (foundStuff.keywords.length > 0) setDisplayedField("keywords");
    else if (foundStuff.partially.length > 0) setDisplayedField("partially");
    else if (foundStuff.categories.length > 0) setDisplayedField("categories");
  }, [foundStuff]);

  const fireButtons = [
    { result: "exact", color: "#6944ef" },
    { result: "partially", color: "#44c9ef" },
    { result: "keywords", color: "#ef8c44" },
    { result: "categories", color: "#ef8c44" },
  ];

  const localButtons = [
    { result: "open", color: "#6944ef" },
    { result: "saved", color: "#44c9ef" },
    { result: "general", color: "#44c9ef" },
  ];

  return (
    <div
      className="divRow"
      style={{ width: "50%", justifyContent: "space-around" }}
    >
      <ButtonBar
        barName={"general"}
        setDisplayedField={setDisplayedField}
        buttons={fireButtons}
        found={foundStuff}
        displayedField={displayedField}
      />

      <ButtonBar
        barName={"locally"}
        setDisplayedField={setDisplayedField}
        buttons={localButtons}
        found={foundStuff}
        displayedField={displayedField}
      />
    </div>
  );
};

const ButtonBar = ({
  barName,
  setDisplayedField,
  buttons,
  found,
  displayedField,
}) => {
  return (
    <div
      className="divColumn"
      style={{ justifyContent: "center", marginTop: "5px" }}
    >
      <div className="textBold" style={{ color: "#272727" }}>
        {barName}
      </div>
      <div className="divRow" style={{}}>
        {buttons.map((b) => (
          <ResultButton
            key={b.result}
            result={b.result}
            setDisplayedField={setDisplayedField}
            color={b.color}
            displayedField={displayedField}
            foundStuff={found}
          />
        ))}
      </div>
    </div>
  );
};

const ResultButton = ({
  result,
  setDisplayedField,
  color,
  displayedField,
  foundStuff,
}) => {
  const hover = useHover();

  return (
    <div
      onClick={() => setDisplayedField(result)}
      className="divRow"
      style={{
        position: "relative",
        border: "5px solid grey",
        width: "110px",
        height: "50px",
        marginLeft: "5px",
        marginRight: "5px",
        borderRadius: "1rem/1rem",
      }}
      {...hover.divProps}
    >
      <div
        style={{
          position: "absolute",
          opacity: result == displayedField ? "0%" : "10%",
          width: "100%",
          height: "100%",
          backgroundColor: color,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: ".5rem/.5rem",
        }}
      />

      <div
        className="divColumn"
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: result == displayedField ? color : null,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: ".5rem/.5rem",
        }}
      >
        {`${foundStuff[result].length} found`}
        <div
          style={{
            fontFamily: "Roboto-Regular",
            fontStyle: "italic",
            color: "#0f0f0f",
            fontSize: "14px",
            color: result == displayedField ? "white" : "#000000",
          }}
        ></div>
        <div className="divRow">
          <Checkbox item={result} otherItem={displayedField} />
          <div
            className="textBoldWhite"
            style={{
              marginLeft: "5px",
              opacity: "100%",
              color: result == displayedField ? "white" : "#000000",
            }}
          >
            {result}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultButtons;
